import script from "./mul-upload-img.vue?vue&type=script&setup=true&lang=js"
export * from "./mul-upload-img.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__